<template>
    <!-- Ginny pregunta -->
    <div
        v-scroll="handleScrollGroup"
        class="function-app--functionality function-app--functionality__white"
        data-scroll-once="true"
    >
        <div class="container">
            <div class="row function-app--content">
                <div
                    class="js-scroll col-md-7 function-app--text d-flex flex-column fast"
                    data-scroll-class="animated slideInUp"
                >
                    <h2>
                        ¿Cómo vincular las notificaciones de tu correo?
                    </h2>
                    <p>
                        Para asociar tu cuenta de email con nuestro sistema, es indispensable que tengas las notificaciones
                        bancarias de consumo activas. La aplicación no toma ninguna información de tu cuenta de banco,
                        solo registra tus gastos a través de dichas notificaciones. Descarga nuestro PDF y sigue los pasos para este proceso.
                    </p>

                    <div class="btn--container d-flex align-center flex-wrap">
                        <a href='/vinculacion-ginny-gmail.pdf' target='_blank' class="btn btn-google btn-big">
                            <i class="icon">
                                <img alt="Icono Gmail" src="@/assets/images/icons/gmail.png">
                            </i>
                            <span>Descargar para Gmail</span>
                        </a>
                        <a href='/vinculacion-ginny-outlook.pdf' target='_blank' class="btn btn-outlook btn-big">
                            <i class="icon">
                                <img alt="Icono Outlook" src="@/assets/images/icons/outlook.png">
                            </i>
                            <span>Descargar para Outlook</span>
                        </a>
                    </div>

                    <div class="row warning-text">
                        <i>* Debes de realizar este proceso para que la aplicación funcione correctamente.</i>
                    </div>

                </div>
                <div class="col-md-5 function-app--img d-flex justify-content-center">
                    <img
                        class="img-fluid fast js-scroll"
                        data-scroll-class="animated slideInRight"
                        alt="Vista de la Aplicación"
                        src="@/assets/images/sections/app-mock-3.png"
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FunctionalitySection'
};
</script>
<style lang="scss" scoped>
.function-app--functionality {
    overflow: hidden;

    .function-app--title {
        font-size: $small-font-size;
        padding-top: 80px;
    }

    h2,
    h5 {
        font-family: $primary-font;
        font-size: $large-font-size;
        color: $title-grey;
        margin-bottom: 1.5rem;
    }

    h5 {
        font-size: $medium-font-size;
        margin-top: 1.5rem;
    }

    p {
        font-size: $small-font-size;
        margin-bottom: 2rem;
    }

    .function-app--content {
        padding-top: 60px;

        .function-app--text {
             margin-top: -40px;

            .btn-orange {
                padding: 0.75rem 1.7rem;
            }

            .btn--container {
                .btn {
                    margin: .2rem;
                    width: 100%;
                    max-width: 270px;
                }
            }
        }

        .function-app--img {
            overflow: hidden;
        }
    }

    &__white {
        background-color: #fff;
    }

}
// Medium devices (desktops large, 1024px and up)
@media screen and (max-width: 1024px) {
    .function-app--functionality {
        p {
            font-size: $mobile-small-font-size;
        }
    }
}
// Medium devices (tablets, 991px and up)
@media screen and (max-width: 991px) {
    .function-app--functionality {
        .container {
            max-width: 920px;
        }
        .function-app--content {
            display: flex;
            flex-direction: row;
            align-items: center;

            .function-app--text,
            .function-app--img {
                max-width: 100%;
            }

            .function-app--text {
                margin-top: -260px;

                p {
                    font-size: $mobile-small-font-size;
                }
                .function-app--manual {
                    text-align: center;
                }
            }

            .function-app--img {
                display: flex;
                justify-content: flex-end;

                img {
                    max-width: 100%;
                    height: auto;
                    min-height: 350px!important;
                }
            }
        }
    }
}
// Medium devices (tablets, 768px and up)
@media screen and (max-width: 768px) {
    .function-app--functionality {
        .function-app--content {
            flex-direction: column;

            .btn--container {
                justify-content: center;
                align-items: center;
            }

            .function-app--text {
                max-width: 906px;
                margin-top: -40px;

                .warning-text {
                    margin: 20px auto;
                }

                .function-app--manual {
                    h5 {
                        font-size: 24px;
                    }
                }
            }

            .function-app--img {
                img {
                    max-width: 50%;
                    height: auto;
                    margin-right: -7%;
                    margin-top: -15%;
                    display: none;
                }
            }
        }
    }
}
// Medium devices (tablet 767)
@media screen and (max-width: 767px) {
    .function-app--functionality {
        .function-app--content {
            .function-app--img {
                justify-content: center;

                img {
                    display: none;
                }
            }
        }
    }
}
// Medium devices (mobile, 480px and up)
@media screen and (max-width: 480px) {
    .function-app--functionality {
        align-items: flex-start !important;

        h2,
        h5 {
            font-size: $mobile-large-font-size;;
            color: $title-grey;
            margin-bottom: 1.5rem;
        }

        .function-app--title {
            padding-top: 0px!important;
        }

        h1 {
            margin-bottom: 0px;
            margin-left: 15px;
        }

        .function-app--content {
            .function-app--text,
            .function-app--img {
                max-width: 100%;
            }

            .function-app--text {
                .function-app--manual {
                    h5 {
                        font-size: $small-font-size;
                        text-align: left;
                    }

                    p {
                        text-align: left;
                    }
                }
            }

            .function-app--img {
                justify-content: center;

                img {
                    display: none;
                }
            }
        }
    }
}
</style>